module.exports = __webpack_public_path__ + "media/images/gold-medal-c6e4a06f893391c3ccaccbf253ec7c49.svg";